/**
 * Dream4 Webapp — Acesso centralizado a variáveis de ambiente
 * -----------------------------------------------------------
 * Fonte única para leitura de process.env. Não importar process.env
 * diretamente em outros arquivos — sempre usar este módulo.
 *
 * REGRAS:
 *   - Toda variável obrigatória passa por required() — falha rápida e clara
 *     se faltar (lançando Error já no carregamento do módulo).
 *   - Toda variável opcional usa optional() com default explícito.
 *   - Toda nova variável adicionada aqui exige atualização do .env.example
 *     no MESMO PR.
 *
 * Em CRA, variáveis com prefixo REACT_APP_ são substituídas em BUILD time.
 * Mudanças no .env exigem novo `npm run build` (ou restart do `npm start`).
 *
 * Para validar antes do build, rodar: `npm run check:env`
 */

function required(name) {
	const value = process.env[name];
	if (value === undefined || value === null || value === '') {
		throw new Error(
			`[env] Variável de ambiente obrigatória ausente: ${name}\n` +
			`  → Copie .env.example para .env e preencha o valor.\n` +
			`  → Rode "npm run check:env" para validar antes do build.`
		);
	}
	return value;
}

function optional(name, defaultValue) {
	const value = process.env[name];
	return (value === undefined || value === null || value === '') ? defaultValue : value;
}

const env = {
	// Ambiente lógico
	APP_ENV: required('REACT_APP_ENV'),

	// API Dream4
	API_URL: required('REACT_APP_API_URL'),
	WS_URL:  required('REACT_APP_WS_URL'),

	// Google reCAPTCHA v2
	RECAPTCHA_SITE_KEY: required('REACT_APP_RECAPTCHA_SITE_KEY'),

	// Google Maps Platform
	GOOGLE_MAPS_API_KEY: required('REACT_APP_GOOGLE_MAPS_API_KEY'),

	// Opcionais
	WHATSAPP_PHONE: optional('REACT_APP_WHATSAPP_PHONE', '+552140209749'),

	// Sentry (error tracking) — quando vazio, Sentry fica off (útil para dev local).
	SENTRY_DSN: optional('REACT_APP_SENTRY_DSN', ''),

	// Domínio público dedicado (opcional). Se setado (ex.: "pagar.dream4.net"), o app
	// SÓ serve as rotas públicas (/pagamento, /hotel) nesse hostname — o resto vira 404
	// (a B2B nunca renderiza lá). Vazio = comportamento atual (tudo no mesmo domínio).
	PUBLIC_HOST: optional('REACT_APP_PUBLIC_HOST', ''),
	// Base das URLs públicas geradas (link de pagamento/hotel). Vazio = window.location.origin.
	PUBLIC_BASE_URL: optional('REACT_APP_PUBLIC_BASE_URL', ''),
};

// Helper de conveniência para componentes que precisam saber o ambiente.
env.isDevelopment = env.APP_ENV === 'development';
env.isStaging     = env.APP_ENV === 'staging';
env.isProduction  = env.APP_ENV === 'production';

export default env;
